<template>
  <div>
    <div class="mb-2 ml-5 text-end">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-switch v-if="isUsingTechnicalSkillsCategories !== null" dense color="secondary" inset v-model="isUsingTechnicalSkillsCategories" class="mt-1" hide-details>
            <template v-slot:label>
              <small style="margin-top: -2px">{{ $t('2') }}</small>
            </template>
          </v-switch>
        </v-flex>
      </v-layout>
    </div>

    <v-card v-if="profile.skills.isUsingTechnicalSkillsDescription" flat class="px-4 pb-6">
      <technical-skills-description :profile="profile" :isOcrResultsLoaded="isOcrResultsLoaded" />
    </v-card>

    <div v-else-if="dossier.isUsingParserV2">
      <edit-technical-skills-v-2 :profile="profile" />
    </div>

    <div v-else>
      
      <v-card outlined class="px-2 mx-2 pt-3 pb-3">
        <v-layout wrap>
          <v-flex xs12>
            <v-autocomplete
              v-if="isAlgoliaReady"
              v-model="skillIds"
              :items.sync="autocompleteItems"
              :search-input.sync="searchInput"
              :filter="autocompleteFilter"
              :no-filter="true"
              :item-text="getAutocompleteSkillText"
              item-value="id"
              :label="$t('1')"
              prepend-inner-icon="mdi-magnify"
              persistent-hint
              multiple
              outlined
              dense
              hide-details
            >
              <template v-slot:selection="">
              </template>
              <template v-slot:no-data>
                <v-list-item>
                  <v-layout wrap>
                    <v-flex xs12 text-center>
                      <div><small>{{ $t('5') }}</small></div>
                      <div class="mb-3 mt-2">
                        <v-btn class="primary" small @click="showAddCustomSkillDialog = true">
                          <v-icon small class="mr-2">mdi-plus</v-icon>
                          {{ $t('6') }}
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 text-end mt-2>
            <v-btn x-small outlined @click="showAddCustomSkillDialog = true">
              <v-icon x-small class="mr-2">mdi-plus</v-icon>
              {{ $t('6') }}
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <technical-skills-recommendation :technicalSkills="profile.skills.technicalSkills" @addRecommendedSkill="addRecommendedSkill"/>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card flat class="px-4 pt-6 pb-6">
        <v-layout wrap>
          <v-flex xs12 mt-3 v-if="mainSkills.length > 0">
            <div>
              <h3>
                {{ $t('4') }}
                <v-btn x-small outlined @click="isShowingReorderMainSkillsDialog = true" class="ml-4">
                  <v-icon x-small class="mr-2">mdi-arrow-split-horizontal</v-icon>
                  {{ $t('4btn') }}
                </v-btn>
              </h3>
            </div>
            <div class="mb-4">
              <v-chip small v-for="(skill, index) in mainSkills" :key="index" class="mt-1 mr-2" close @click:close="deleteSkillById(skill.id)">
                <v-icon small @click="unSetAsMainSkill(skill)" left>mdi-star</v-icon>
                {{ getSkillName(getSkillById(skill.id)) }}
              </v-chip>
            </div>
            <v-divider class="mt-3"></v-divider>
          </v-flex>
          <v-flex xs12 class="mt-4" v-if="categories.length > 0">
            <h3>{{ $t('13') }}</h3>
          </v-flex>
          <v-flex xs12 v-for="(category, key) in categories" :key="key" mb-3>
            <div><b>{{ getCategoryName(category.id) }} :</b></div>
            <div>
              <v-chip small v-for="(skill, key2) in category.skills" :key="key2" class="mt-1 mr-2" close @click:close="deleteSkillById(skill.id)">
                <v-icon small v-if="skill.isMain" left @click="unSetAsMainSkill(skill)">mdi-star</v-icon>
                <v-icon small v-else left @click="setAsMainSkill(skill)">mdi-star-outline</v-icon>
                {{ getSkillName(getSkillById(skill.id)) }}
              </v-chip>
            </div>
          </v-flex>
          <v-flex xs12>
            <span>{{ $t('14') }}</span>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
    <v-dialog v-model="showAddCustomSkillDialog" width="50%">
      <v-card class="pa-6">
        <v-layout wrap>
          <v-flex xs12 text-center>
            <h3 class="mb-6">{{ $t('6') }}</h3>
            <v-form>
              <v-text-field v-model="newCustomSkill.name" :label="$t('7')" outlined dense ref="newCustomSkillName" autocomplete="off"/>
              <v-autocomplete
                v-if="isAlgoliaReadyForCategories"
                v-model="newCustomSkill.categoryId"
                :label="$t('8')"
                :items.sync="autocompleteItemsForCategories"
                :search-input.sync="searchInputForCategories"
                :filter="autocompleteFilterForCategories"
                :no-filter="true"
                :item-text="getCategoryNameForAutocomplete"
                prepend-inner-icon="mdi-magnify"
                item-value="id"
                outlined
                dense
                hide-details
                :no-data-text="$t('noDataText')"
              />
              <v-checkbox v-model="newCustomSkill.isMain" :label="$t('9')" outlined dense/>
              <v-btn @click="addNewCustomSkill" :disabled="!newCustomSkill.name || !newCustomSkill.categoryId" class="primary">{{ $t('10') }}</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowingReorderMainSkillsDialog" persistent v-if="isShowingReorderMainSkillsDialog" width="60%">
      <v-card class="pa-6">
        <v-layout wrap>
          <v-flex xs12>
            <div class="mb-6 text-center">
              <h3>{{ $t('11') }}</h3>
              <small>{{ $t('12') }}</small>
            </div>
            <reorder-main-skills :mainSkills="mainSkills" @updateMainSkillsOrder="updateMainSkillsOrder"/>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
const allSkills = require('@/assets/app/data/allSkills.json')
const allCategories = require('@/assets/app/data/allCategories.json')

import { mapGetters } from "vuex";

import algoliasearch from 'algoliasearch/lite';
const ALGOLIA_APP_ID = 'GDWN6HP8CM'
const ALGOLIA_INDEX_NAME = process.env.VUE_APP_ENV === 'production' ? 'prod_technicalSkills' : 'dev_technicalSkills'
const ALGOLIA_INDEX_NAME_FOR_CATEGORIES = process.env.VUE_APP_ENV === 'production' ? 'prod_categories' : 'dev_categories'
const ALGOLIA_PUBLIC_KEY = '09b7cd173d20bdd272dfcbd8b3fb7925'

import TechnicalSkillsDescription from "@/components/profile/TechnicalSkillsDescription";
import ReorderMainSkills from '@/components/profile/ReorderMainSkills';
import TechnicalSkillsRecommendation from "@/components/profile/TechnicalSkillsRecommendation"
import EditTechnicalSkillsV2 from "@/components/profile/EditTechnicalSkillsV2"

export default {
  components: {
    TechnicalSkillsDescription,
    ReorderMainSkills,
    TechnicalSkillsRecommendation,
    EditTechnicalSkillsV2
  },
  props: {
    profile: Object,
    dossier: Object,
    isOcrResultsLoaded: Boolean,
  },
  data:() => ({
    skillIds: [],
    allSkills: allSkills.sort((a, b) => a.name > b.name ? 1 : -1),
    showAddCustomSkillDialog: false,
    newCustomSkill: {
      name: '',
      categoryId: null,
      isMain: true
    },
    allCategoriesAsList: [],
    isShowingReorderMainSkillsDialog: false,
    isUsingTechnicalSkillsCategories: null,
    searchInput: ' ',
    algoliaCurrentHits: [],
    algoliaClient: null,
    algoliaIndex: null,
    isAlgoliaReady: false,
    searchInputForCategories: '',
    algoliaCurrentHitsForCategories: [],
    algoliaClientForCategories: null,
    algoliaIndexForCategories: null,
    isAlgoliaReadyForCategories: false,
  }),
  mounted() {
    document.getElementById('profile-sections-container').scrollTop = 0

    this.isUsingTechnicalSkillsCategories = !this.profile.skills.isUsingTechnicalSkillsDescription

    // Set skillIds (without custom skills)
    this.skillIds = this.profile.skills.technicalSkills.map(skill => skill.id).filter(skillId => !skillId.startsWith('CUSTOM_'))

    // Set allCategoriesAsList
    for (const [categoryId, categoryNamesDict] of Object.entries(allCategories)) {
      if (parseInt(categoryId)) { // don't add the old legacy categories names
        this.allCategoriesAsList.push({
          id: categoryId,
          name: categoryNamesDict[this.user.data.locale.toUpperCase()]
        })
      }
    }
    this.allCategoriesAsList.sort((a,b) => a.name > b.name ? 1 : -1)

    this.initAlgolia()
    this.initAlgoliaForCategories()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    mainSkills() {
      return this.profile.skills.technicalSkills.filter(skill => skill.isMain)
    },
    categories() {
      let categories = []
      // Create categories
      for (const [categoryId, categoryNamesDict] of Object.entries(allCategories)) {
        categories.push({
          id: categoryId,
          name: categoryNamesDict[this.profile.cvLanguage],
          skills: []
        })
      }
      
      // Add them their skills
      for (let skill of this.profile.skills.technicalSkills) {
        const skillCategoryId = this.getSkillById(skill.id).categoryId
        for (let category of categories) {
          if (skillCategoryId === category.id) {
            category.skills.push(skill)
          }
        }
      }

      // Sort the skills by their names
      for (let category of categories) {
        category.skills.sort((a, b) => this.getSkillById(a.id).name > this.getSkillById(b.id).name ? 1 : -1)
      }

      // Sort the categories by their number of skills
      return categories.filter(category => category.skills.length > 0).sort((a,b) => {
        if (b.skills.length === a.skills.length) return a.name > b.name ? 1 : -1
        else return b.skills.length - a.skills.length
      })
    },
    autocompleteItems() {
      return this.algoliaCurrentHits
    },
    autocompleteItemsForCategories() {
      return this.algoliaCurrentHitsForCategories
    },
  },
  methods: {
    getCategoryName(categoryId) {
      return allCategories[categoryId][this.user.data.locale.toUpperCase()]
    },
    getSkillById(skillId) {
      const skill = allSkills.find(skill => skill.id === skillId || skill.legacyId === skillId)
      if (skill) return skill
      else {
        // Custom skill here
        return this.profile.skills.technicalSkills.find(skill => skill.id === skillId)
      }
    },
    deleteSkillById(skillId) {
      if (skillId.startsWith('CUSTOM_')) {
        const skill = this.getSkillById(skillId)
        this.unSetAsMainSkill(skill)
        this.profile.skills.technicalSkills = this.profile.skills.technicalSkills.filter(skill => skill.id !== skillId)
      } else {
        this.skillIds = this.skillIds.filter(id => id !== skillId)
      }
    },
    setAsMainSkill(skill) {
      const previousSkillsListWithoutThisSkill = JSON.parse(JSON.stringify(this.profile.skills.technicalSkills)).filter(skill2 => skill2.id !== skill.id)
      skill.isMain = true
      this.profile.skills.technicalSkills = previousSkillsListWithoutThisSkill.filter(skill => skill.isMain)
        .concat([skill])
        .concat(previousSkillsListWithoutThisSkill.filter(skill => !skill.isMain))
    },
    unSetAsMainSkill(skill) {
      const previousSkillsListWithoutThisSkill = JSON.parse(JSON.stringify(this.profile.skills.technicalSkills)).filter(skill2 => skill2.id !== skill.id)
      skill.isMain = false
      this.profile.skills.technicalSkills = previousSkillsListWithoutThisSkill.filter(skill => skill.isMain)
        .concat([skill])
        .concat(previousSkillsListWithoutThisSkill.filter(skill => !skill.isMain))
    },
    addNewCustomSkill() {
      const skill = {
        id: `CUSTOM_${this.newCustomSkill.name}`,
        name: this.newCustomSkill.name,
        categoryId: this.newCustomSkill.categoryId,
        isMain: this.newCustomSkill.isMain
      }
      this.profile.skills.technicalSkills.push(skill)
      // Set as main skill and update order
      if (this.newCustomSkill.isMain) this.setAsMainSkill(skill)
      else this.unSetAsMainSkill(skill)
      this.showAddCustomSkillDialog = false
      this.newCustomSkill = {
        name: '',
        categoryId: null,
        isMain: true
      }
    },
    updateMainSkillsOrder(newMainSkills) {
      // New technicalSkills list is :
      // the newly re-ordered main skills
      // + the unchanged non-main skills
      const previousSkillsList = JSON.parse(JSON.stringify(this.profile.skills.technicalSkills))
      this.profile.skills.technicalSkills = newMainSkills.concat(previousSkillsList.filter(skill => !skill.isMain))
      this.isShowingReorderMainSkillsDialog = false
    },
    addRecommendedSkill(skillId) {
      if (!this.profile.skills.technicalSkills.find(skill => skill.id === skillId)) {
        const skill = {
          id: skillId,
          isMain: false
        }
      this.profile.skills.technicalSkills.push(skill)
      // Set as main skill and update order
      this.setAsMainSkill(skill)
      }
      this.skillIds.push(skillId)
      // Note: weird to have to add this.skillIds.push(skillId) and the previous code.
      // But it avoids a bug that occurs when later we try to delete a skill that has been via a recommendation (but it doesn't get removed).
    },
    // autocompleteFilter(item, queryText) {
    //   const searchText = queryText.toLowerCase()
    //     .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // remove accents ex: é -> e
    //     .replace(/[^a-z0-9.+# ]+/g, " ").replace(/  +/g, ' ');
    //   const texts = [item.name.toLowerCase()]
    //     .concat(item.aliases.map(alias => alias.toLowerCase()))
    //     .concat(Object.values(item.names).map(name => name.toLowerCase()))
    //     // .concat(item.description ? [item.description.toLowerCase()] : [])
    //   return texts.find(text => text.indexOf(searchText.toLowerCase()) > -1)
    // },
    async initAlgolia() {
      this.algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_PUBLIC_KEY);
      this.algoliaIndex = this.algoliaClient.initIndex(ALGOLIA_INDEX_NAME)
      this.search()
      this.isAlgoliaReady = true
    },
    async search() {
      const { hits } = await this.algoliaIndex.search(this.searchInput || '', {
        hitsPerPage: 50,
      })
      this.algoliaCurrentHits = hits
      this.scrollToTopOfAllAutocompletesListResults()
    },
    scrollToTopOfAllAutocompletesListResults(){
      // For any autocomplete (if it has been opened at least one) [both skills autocomplete and categories autocomplete]
      // Try to scroll it to top
      document.querySelectorAll('.v-autocomplete__content').forEach(scrollList => {
        if (scrollList) {
          let firstElement = scrollList.querySelector('.v-list-item')
          if (firstElement && firstElement.offsetTop) {
            scrollList.scrollTop = firstElement.offsetTop
          }
        }
      })
    },
    autocompleteFilter(val) {
      return this.algoliaCurrentHits.map(hit => hit.id).includes(val.id)
    },
    getSkillName(skill) {
      const userLocale = this.user.data.locale
      if (skill.names && userLocale in skill.names) return skill.names[userLocale]
      else return skill.name
    },
    getAutocompleteSkillText(skill) {
      try {
        return `${this.getSkillName(skill)} (${this.getCategoryName(skill.categoryId)})`
      } catch {
        return this.getSkillName(skill)
      }
    },

    async initAlgoliaForCategories() {
      this.algoliaClientForCategories = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_PUBLIC_KEY);
      this.algoliaIndexForCategories = this.algoliaClientForCategories.initIndex(ALGOLIA_INDEX_NAME_FOR_CATEGORIES)
      this.searchForCategories()
      this.isAlgoliaReadyForCategories = true
    },
    async searchForCategories() {
      const { hits } = await this.algoliaIndexForCategories.search(this.searchInputForCategories || '', {
        hitsPerPage: 50,
      })
      this.algoliaCurrentHitsForCategories = hits
      this.scrollToTopOfAllAutocompletesListResults()
    },
    autocompleteFilterForCategories(val) {
      return this.algoliaCurrentHitsForCategories.map(hit => hit.id).includes(val.id)
    },
    getCategoryNameForAutocomplete(category) {
      const userLocaleUppercased = this.user.data.locale.toUpperCase()
      if (category.names && userLocaleUppercased in category.names) return category.names[userLocaleUppercased]
      else return category.name
    }
  },
  watch: {
    async searchInput() {
      this.search()
    },
    async searchInputForCategories() {
      this.searchForCategories()
    },
    skillIds: {
      handler(val, oldVal) {
        // Add to this.profile.skills.technicalSkills the skills that were added from this.skillIds
        const addedSkillIds = val.filter(skillId => !oldVal.find(skillId2 => skillId === skillId2))
        for (let skillId of addedSkillIds) {
          if (!this.profile.skills.technicalSkills.find(skill => skill.id === skillId)) {
            const skill = {
              id: skillId,
              isMain: false
            }
            this.profile.skills.technicalSkills.push(skill)
            // Set as main skill and update order
            this.setAsMainSkill(skill)
          }
        }
        // Remove to this.profile.skills.technicalSkills the skills that were removed from this.skillIds
        const removedSkillIds = oldVal.filter(skillId => !val.find(skillId2 => skillId === skillId2))
        this.profile.skills.technicalSkills = this.profile.skills.technicalSkills.filter(skill => !removedSkillIds.includes(skill.id))
      }
    },
    showAddCustomSkillDialog: {
      handler(val) {
        if (val) {
          this.newCustomSkill.name = this.searchInput
          setTimeout(() => {
            this.$refs.newCustomSkillName.focus()
          }, 1)
        } else {
          this.newCustomSkill = {
            name: '',
            categoryId: null,
            isMain: true
          }
        }
      }
    },
    isUsingTechnicalSkillsCategories: {
      handler() {
        this.profile.skills.isUsingTechnicalSkillsDescription = !this.isUsingTechnicalSkillsCategories
      }
    }
  }
};
</script>


<i18n>
{
  "fr": {
    "1": "Tapez le nom d'une technologie...",
    "2": "Utiliser la catégorisation des technologies",
    "3": "Utiliser le texte du CV",
    "4": "Compétences principales",
    "4btn": "Réordonner",
    "5": "Pas de résultat.",
    "6": "Ajouter une technologie personnalisée",
    "7": "Nom de la technologie personnalisée",
    "8": "Rechercher une catégorie...",
    "9": "Compétence principale",
    "10": "Ajouter",
    "11": "Réordonner les compétences principales",
    "12": "Réorganisez les compétences dans l'ordre que vous souhaitez.",
    "13": "Catégories",
    "14": "Pour condenser la présentation des compétences techniques, les technologies qui sont seules dans leurs catégories sont parfois regroupées dans une catégorie nommée \"Autres\".",
    "noDataText": "Pas de catégorie correspondant à votre recherche."
  },
  "en": {
    "1": "Type the name of a technology...",
    "2": "Use categories of technologies",
    "3": "Use text from the CV",
    "4": "Main skills",
    "4btn": "Re-order",
    "5": "No result.",
    "6": "Add a custom technology",
    "7": "Name of the custom technology",
    "8": "Search for a category...",
    "9": "Main skill",
    "10": "Add",
    "11": "Re-order the main skills",
    "12": "Sort the skills the way you want.",
    "13": "Categories",
    "14": "To make more compact the presentation of technical skills, technologies which are alone in their categories may be grouped in a category named \"Others\".",
    "noDataText": "No category corresponding to your search."
  }
}
</i18n>